"use strict";
// (C) 2020-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.INFO_TEXT_COLOR = exports.GD_COLOR_WHITE = exports.GD_COLOR_HIGHLIGHT = void 0;
/**
 * @internal
 */
exports.GD_COLOR_HIGHLIGHT = "#14b2e2";
/**
 * @internal
 */
exports.GD_COLOR_WHITE = "#fff";
/**
 * @internal
 */
exports.INFO_TEXT_COLOR = "#909293";
//# sourceMappingURL=constants.js.map